import axios from 'axios';
import { ApiUtil } from '@/shared/api';

const loginUrl = import.meta.env.VITE_VIVACLASS_DOMAIN;
const vivasamApi = import.meta.env.VITE_VIVASAM_API;
const deploy = import.meta.env.VITE_DEPLOY;
const MEMBER_INFO_REQUEST_TIMEOUT = 15_000;

export const loginApi = {
    getSessionInfo: () => {
        if (deploy == 'local') {
            const getParams = new URLSearchParams(window.location.search);

            if (getParams.get('token'))
                localStorage.setItem('testToken', getParams.get('token') || '');
            const tokenValue = getParams.get('token')
                ? getParams.get('token')
                : localStorage.getItem('testToken');

            return axios.get<API.SessionIfo.Res>(
                `https://t-vdtapi.vivasam.com/session/sessionInfo?cookieId=${tokenValue}`
            );
        } else {
            return axios.get<API.SessionIfo.Res>(loginUrl + '/session/sessionInfoVivasam', {
                withCredentials: true,
            });
        }
    },
    createJwtToken: (param: API.CommonJwt.Req) => {
        return ApiUtil._get<API.CommonJwt.Res>('/common/jwt', param);
    },
    refreshJwtToken: (param: API.CommonJwtRefresh.Req) => {
        return ApiUtil._post<API.CommonJwtRefresh.Res>('/common/jwt/refresh', param);
    },
    getMemberInfo: (param: API.GetMemberInfo.Req) => {
        const queryString = new URLSearchParams(param as any).toString();
        return axios.get<API.GetMemberInfo.Res>(
            `${vivasamApi}/api/common/getMemberInfo?${queryString}`,
            {
                withCredentials: false,
                timeout: MEMBER_INFO_REQUEST_TIMEOUT,
            }
        );
    },
};
